<template>
  <LayoutDefault>
    <h2 class="font-medium text-2xl px-8 text-center leading-tight mt-8">
      Parabéns! Você completou a Lição
    </h2>
    <p class="mt-4 text-gray-600 font-light text-center">
      Que tal aproveitar o embalo e começar outra lição agora?
    </p>
    <img
      src="@/assets/img/icons/lessonCompleted.svg"
      width="100"
      alt=""
      srcset=""
      class="mx-auto mt-8"
    />
    <hr class="mt-8 w-2/3 mx-auto" />

    <h3 class="text-center font-medium mt-6">E o que você achou?</h3>
    <p class="text-center font-light text-gray-500 text-sm">
      Ajude a gente a melhorar!
    </p>

    <div class="mx-auto text-center mt-5">
      <img
        v-for="(url, index) in urls"
        :key="index"
        :src="`/img/icons/ratings/${url}`"
        alt=""
        class="inline px-1 cursor-pointer"
        svg-inline
        @click="handleClickRating(index)"
      />
    </div>

    <div v-if="activeRating < 4 && activeRating != 0">
      <hr class="mt-6 w-2/3 mx-auto" />

      <h4 class="text-left font-light text-gray-600 mt-6 px-4 mb-4">
        Ajude a gente. Como podemos melhorar?
      </h4>

      <label
        class="custom-label flex items-center px-4 mt-2"
        v-for="(feedback, index) in possibleFeedbacks"
        :key="index"
      >
        <div
          class="bg-white shadow w-6 h-6 p-1 flex justify-center items-center mr-2"
        >
          <input
            type="checkbox"
            class="hidden"
            @change="handleClickFeedback(feedback)"
          />
          <svg class="hidden w-4 h-4 text-green-600 pointer-events-none" viewBox="0 0 172 172" v-bind:srcset="''" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" stroke-width="none" stroke-miterlimit="10" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode:normal"><path d="M0 172V0h172v172z"/><path d="M145.433 37.933L64.5 118.866 33.734 88.1 23.6 98.234l40.9 40.9 91.067-91.067z" fill="currentColor"/></g></svg>
        </div>
        <span class="select-none text-sm text-light"> {{ feedback }}</span>
      </label>
    </div>
    <div v-if="activeRating">
      <hr class="mt-6 w-2/3 mx-auto" />
      <button @click="handleClickButton" class="button button-primary mt-4">
        Finalizar
      </button>
    </div>
  </LayoutDefault>
</template>
<script>
import LayoutDefault from "../layouts/LayoutDefault";
export default {
  name: "LessonCompletedView",
  components: {
    LayoutDefault
  },
  data() {
    return {
      lesson: {},
      isLastChallenge: true,
      activeRating: "",
      possibleFeedbacks: [
        "Muito Fácil",
        "Muito Difícil",
        "Desatualizado ou Errado"
      ],
      feedbackArray: []
    };
  },

  computed: {
    urls: function() {
      const arrays = [];
      for (let i = 1; i < 6; i++) {
        let status = i === this.activeRating ? "active" : "inactive";
        arrays.push(`${i}/${status}.svg`);
      }
      return arrays;
    },
    challenge: function() {
      if (this.isLastChallenge) {
        return this.$store.state.lastChallenge;
      } else {
        return this.$store.state.selectedChallenge;
      }
    },
    isLessonCompleted: function() {
      if (this.lesson) {
        return this.lesson.contents.every(content => {
          return content.completed_at;
        });
      }
      return false;
    }
  },

  created() {
    // esse é o last challenge?
    if (this.$route.params.challengeId) {
      this.isLastChallenge = false;
    } else {
      this.isLastChallenge = true;
    }

    // Vamos ver se temos um challengeId (antigo) ou se vamos pegar o LastChallenge
    if (this.isLastChallenge) {
      this.$store
        .dispatch("fetchLastChallenge")
        .then(() => {
          this.lesson = this.challenge.lessons[this.$route.params.number - 1];

          // vamos ver se ele acabou a lição  ou não.
          if (!this.userCompletedLesson()) {
            this.$router.push("/desafio");
          }
        })
        .catch();
    } else {
      this.$store
        .dispatch("fetchSelectedChallenge", this.$route.params.challengeId)
        .then(() => {
          this.lesson = this.challenge.lessons[this.$route.params.number - 1];

          if (!this.userCompletedLesson()) {
            this.$router.push(`/desafio/${this.$route.params.challengeId}`);
          }
        })
        .catch();
    }
  },

  // user completou a lesson?

  methods: {
    handleClickButton() {
      if (this.isLastChallenge) {
        this.$router.push("/desafio");
      } else {
        this.$router.push(`/desafio/${this.$route.params.challengeId}`);
      }
    },
    userCompletedLesson() {
      return this.lesson.contents.every(content => {
        return content.completed_at;
      });
    },
    handleClickRating(index) {
      this.activeRating = index + 1; // vamos marcar como ativo.

      this.$http
        .post(`lessons/${this.lesson.id}/feedback`, {
          rating: this.activeRating
        })
        .then(() => {})
        .catch(() => {
          this.$toasted.error("Ops... Algo deu errado...");
        });
    },

    handleClickFeedback(feedback) {
      // se foi checked = true.
      if (event.target.checked) {
        if (this.feedbackArray.indexOf(feedback) === -1) {
          // se não exsite, vamos fazer o push
          this.feedbackArray.push(feedback);
        }
      } else {
        // se foi checked = false
        if (this.feedbackArray.indexOf(feedback) !== -1) {
          // existe, vamos remover.
          this.feedbackArray.splice(this.feedbackArray.indexOf(feedback));
        }
      }

      this.$http
        .post(`lessons/${this.lesson.id}/feedback`, {
          rating: this.activeRating,
          feedbacks: this.feedbackArray
        })
        .then(() => {
          this.$toasted.success("Obrigado por nos ajudar!", {
            icon: "done_outline"
          });
        })
        .catch(() => {
          this.$toasted.error("Ops... Algo deu errado...");
        });
    }
  }
};
</script>
<style>
.custom-label input:checked + svg {
  display: block !important;
}
</style>
